import type { CommentCallbackArgs, CommentConfig } from 'component/comment';
import type { ModeratedComment } from 'feature/moderation/ai-premoderator';
import type { Feature } from 'util/stdtypes';

export type ReplyNotifsConfig = {
    replyNotifsDisabled?: boolean;
};
export const ReplyNotificationsFeature: Feature<CommentConfig, ReplyNotifsConfig> = {
    name: 'Reply Notifications',
    key: 'replynotifications',
    dev: true,
    providesConfig: {
        commentPostTriggers: [postTriggerAsync],
    },
    receivesConfigDefaults: {
        replyNotifsDisabled: false,
    },
};

export async function postTriggerAsync(args: CommentCallbackArgs) {
    const config = args.datastore.getConfig<ReplyNotifsConfig>();
    const isAdmin = args.datastore.getIsAdmin();

    const { replyTo } = args.comment as ModeratedComment;
    if (
        !replyTo || // Do not send reply if no parent exists
        (config.replyNotifsDisabled && !isAdmin) // Admin replies are always posted
    )
        return;
    await args.datastore.callServerAsync('notifs', 'sendNotifsForReply', {
        replyKey: args.commentKey,
        parentKey: replyTo,
    });
}
